export function openLinkInNewTab (link: string): void {
  const anchor = document.createElement('a');
  anchor.href = link;
  anchor.target = '_blank';
  document.body.appendChild(anchor);

  // FIXME если сразу открывать ссылки, то иногда падает ошибка strana_lk-1379
  // добавлен таймаут
  const timer = setTimeout(() => {
    anchor.click();
    document.body.removeChild(anchor);
    clearTimeout(timer);
  }, 500);
}
